exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2ef6a99a] .el-card__body{height:100%}.card__body--nopadding[data-v-2ef6a99a]  .el-card__body{padding:10px}.to-model-preview[data-v-2ef6a99a]{cursor:pointer}.model_message_wrap[data-v-2ef6a99a]{background-color:#f5f5f5!important;color:#000!important}.model_message_wrap[data-v-2ef6a99a]  .el-checkbox__inner{border-color:#000!important}.modelTree-tree[data-v-2ef6a99a]{height:calc(100% - 84px)}", ""]);

// exports
